import { render, staticRenderFns } from "./CompaniaProductos.vue?vue&type=template&id=1e0e88ee"
import script from "./CompaniaProductos.vue?vue&type=script&lang=js"
export * from "./CompaniaProductos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports